import { defineAsyncComponent } from 'vue';

export const salesforceIntegrationMicroFrontends = {
	SalesforceQuoteQuickActions: defineAsyncComponent(
		() => import('./components/SalesforceQuoteQuickActions.vue')
	),
};
